module.exports = __webpack_public_path__ + "img/icon_01.0c271a82.png";